import { TOLGEE_PROCESSOR_NAME } from '@tolgee/i18next';
import axios from 'axios';
import { tolgeeInitOptions } from '../i18n';
import { Queue as PromiseQueue } from './promiseQueueExecutor';

export const tolgeeOptions = (tolgee, options) => {
  let processors;
  if (typeof options.postProcess === 'string') {
    processors = [options.postProcess, TOLGEE_PROCESSOR_NAME];
  } else if (Array.isArray(options.postProcess)) {
    processors = [...options.postProcess, TOLGEE_PROCESSOR_NAME];
  } else {
    processors = [TOLGEE_PROCESSOR_NAME];
  }
  const newOptions = {
    ...options,
    postProcess: processors,
    i18nFormat: {
      ...options?.i18nFormat,
    },
    react: {
      ...options?.react,
    },
  };
  return newOptions;
};

export const customBackend = tolgee => {
  return {
    type: 'backend',
    name: 'TolgeeBackend',
    init() {},
    read: async function(language, ns, callback) {
      try {
        const translations = await tolgee.loadRecord({
          language,
          namespace: ns,
        });
        callback(null, translations ? Object.fromEntries(translations) : undefined);
      } catch (e) {
        console.error(e);
        callback(true);
      }
    },
    create: async function(languages, namespace, key, fallbackValue) {
      const isKeyExists = await checkIfKeyExists(key, namespace);
      if (isKeyExists) return;
      try {
        console.log({ languages, namespace, key, tolgee });
        const path = `${tolgeeInitOptions.apiUrl}v2/projects/${tolgeeInitOptions.projectId}/keys`;
        const payload = {
          name: key,
          namespace,
          translations: { en: fallbackValue },
          isPlural: false,
        };
        const promiseFn = () => {
          return axios
            .post(path, payload, {
              headers: { 'x-api-key': tolgeeInitOptions.apiKey },
            })
            .then(newKey => console.log({ i18nKeyAdded: newKey }));
        };
        PromiseQueue.enqueue(promiseFn);
      } catch (e) {
        console.error(e);
      }
    },
  };
};

const checkIfKeyExists = async (key, namespace) => {
  let result = false;
  const path = `${tolgeeInitOptions.apiUrl}v2/projects/${tolgeeInitOptions.projectId}/keys/info`;
  const payload = {
    keys: [{ name: key, namespace }],
    languageTags: ['en'],
  };
  try {
    const res = await axios.post(path, payload, {
      headers: { 'x-api-key': tolgeeInitOptions.apiKey },
    });
    if (res?.data?._embedded?.keys?.length) {
      result = true;
    }
  } catch (e) {
    console.log(e);
  }
  return result;
};
